/**
 * Watch User is auth and load profile data
 */
export default (store) => {
    store.watch((state, getters) => getters.isUserAuthenticated, (isUserAuthenticated) => {
        if (isUserAuthenticated) {
            store.dispatch('loadUser');
        }
    });
};
